import React from 'react';

const AnimatedGradient = ({ variant = 'primary' }) => {
  const gradientVariants = {
    primary: {
      background: 'radial-gradient(circle at 20% 50%, rgba(240, 106, 21, 0.15) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255, 138, 61, 0.1) 0%, transparent 50%)',
    },
    secondary: {
      background: 'radial-gradient(circle at 50% 0%, rgba(240, 106, 21, 0.2) 0%, transparent 50%), radial-gradient(circle at 80% 100%, rgba(255, 138, 61, 0.15) 0%, transparent 50%)',
    },
    mesh: {
      background: `
        radial-gradient(at 40% 20%, rgba(240, 106, 21, 0.2) 0px, transparent 50%),
        radial-gradient(at 80% 0%, rgba(255, 138, 61, 0.15) 0px, transparent 50%),
        radial-gradient(at 0% 50%, rgba(240, 106, 21, 0.1) 0px, transparent 50%),
        radial-gradient(at 80% 50%, rgba(255, 138, 61, 0.15) 0px, transparent 50%),
        radial-gradient(at 0% 100%, rgba(240, 106, 21, 0.2) 0px, transparent 50%),
        radial-gradient(at 80% 100%, rgba(255, 138, 61, 0.1) 0px, transparent 50%)
      `,
    },
  };

  return (
    <div
      className="animated-gradient"
      style={{
        position: 'absolute',
        inset: 0,
        ...gradientVariants[variant],
        opacity: 0.6,
        animation: 'gradientShift 15s ease infinite',
        pointerEvents: 'none',
      }}
    />
  );
};

export default AnimatedGradient;
